import types from "../types";

export const fetch_video = () => ({
  type: types.uploadTypes.FETCH_VIDEO,
});

export const fetch_stage = () => ({
  type: types.uploadTypes.FETCH_STAGE,
});
